<template>
	<div>
		<div :class="!isLoginPage ? 'menu_trans' : '' " class="main-header main-header--one clearfix">
			<nav class="main-menu clearfix">
				<div class="main-menu__wrapper clearfix">
					<div class="main-menu__left main-menu__left--two">
						<div class="main-menu__logo">
							<a @click="clickRouter('mb_home')" style="cursor: pointer; ">
								<img class="logo-dark" src="static/picture/logo-1.png" alt="">
								<img class="logo-light" src="static/picture/logo-2.png" alt="">
							</a>
						</div>
					</div>
					<div class="main-menu__main-menu-box main-menu__main-menu-box--two">
						<a @click="handleLang('en_US')" class="mobile-nav__land" v-if="languang == 'zh_CN'">EN</a>
						<a @click="handleLang('zh_CN')" class="mobile-nav__land" v-if="languang == 'en_US'">CN</a>
						<a  class="mobile-nav__toggler"><i class="fa fa-bars"></i></a>
						
					</div>
				
				</div>
			</nav>
		</div>
		<div class="mobile-nav__wrapper">
			<div class="mobile-nav__overlay mobile-nav__toggler"></div>
			<div class="mobile-nav__content">
				<span class="mobile-nav__close mobile-nav__toggler"><i class="fa fa-times"></i></span>

				<div class="logo-box">
					<a href="" aria-label="logo image"><img src="static/picture/footer-logo.png" width="155" alt=""></a>
				</div>

				<!-- 菜单 -->
				<div class="mobile-nav__container">
					<ul class="main-menu__list">
						<li class="dropdown current megamenu">
							<a @click="clickRouter('mb_home')" class="">{{ $t('header.home') }}</a>
						</li>
						<li class="dropdown">
							<a href="#" class="">
                                <span @click="clickRouter('mbProduct','secondaryMenu','software')">{{ $t('header.softwareProducts') }}</span>
                                <button aria-label="dropdown toggler" class=""><i class="fa fa-angle-down"></i></button>
                            </a>
							<ul >
								<li style="font-size: 14px; color: #909399;">{{ $t('header.mb_weldingSoftware') }}</li>

								<li><a @click="clickRouter('mbCloud','productList', 'weldCloud')">{{ $t('header.mb_intelligentWeldingCloud') }}</a></li>
								<li><a @click="clickRouter('mbSoftware','productList', 'pressureVessel')">{{ $t('header.mb_pressureVesselSystem') }}</a></li>
								<li><a @click="clickRouter('mbSoftware','productList', 'steelStructure')">{{ $t('header.mb_steelStructureSystem') }}</a></li>
								<li><a @click="clickRouter('mbSoftware','productList', 'weldTraining')">{{ $t('header.mb_smartTrainingSystem') }}</a></li>
								<li><a @click="clickRouter('mbSoftware','productList', 'pipingSystem')">{{ $t('header.mb_pipingWeldingSystem') }}</a></li>

								<li style="font-size: 14px; color: #909399;">{{ $t('header.mb_professionalSoftware') }}</li>
								
								<li><a @click="clickRouter('mbSoftware','productList', 'weldTechnology')">{{ $t('header.mb_weldingProcessSystem') }}</a></li>
								<li><a @click="clickRouter('mbSoftware','productList', 'welderInformation')">{{ $t('header.mb_welderInfoSystem') }}</a></li>
								<li><a @click="clickRouter('mbSoftware','productList', 'weldMaterialWarehouse')">{{ $t('header.mb_weldingMaterialSystem') }}</a></li>
								<li><a @click="clickRouter('mbSoftware','productList', 'weldSeamTracking')">{{ $t('header.mb_seamTrackingSystem') }}</a></li>
								<li><a @click="clickRouter('mbSoftware','productList', 'videoSystem')">{{ $t('header.mb_videoSystem') }}</a></li>
								<li><a @click="clickRouter('mbSoftware','productList', 'robotSystem')">{{ $t('header.mb_robotSystem') }}</a></li>

								<li style="font-size: 14px; color: #909399;">{{ $t('header.mb_mobileSoftware') }}</li>

								<li><a @click="clickRouter('mbSoftwareApp','productList','groupControlApp')">{{ $t('header.mb_palmGroupControl') }}</a></li>
								<li><a @click="clickRouter('mbSoftwareApp','productList','weldApp')">{{ $t('header.mb_palmWelder') }}</a></li>
								<li><a @click="clickRouter('mbSoftwareApp','productList','operationApp')">{{ $t('header.mb_palmOps') }}</a></li>
								<li><a @click="clickRouter('mbSoftware','productList', 'groupControlApplet')">{{ $t('header.mb_wechatMiniProgram') }}</a></li>
								<li><a @click="clickRouter('mbSoftware','productList', 'databaseApplet')">{{ $t('header.mb_dataLibraryMiniProgram') }}</a></li>

							</ul>
						</li>
						<li class="dropdown">
							<a href="#">
                                <span @click="clickRouter('mbProduct','secondaryMenu', 'hardware')">{{ $t('header.hardwareProducts') }}</span>
                                <button aria-label="dropdown toggler"><i class="fa fa-angle-down"></i></button>
                            </a>
							<ul >
								<li style="font-size: 14px; color: #909399;">{{ $t('header.mb_intelligentTerminal') }}</li>

								<li><a @click="clickRouter('mbHardware','productList', 'ATQ-CJ500-4G')">{{ $t('header.mb_dataCollector') }}</a></li>
								<li><a @click="clickRouter('mbHardware','productList', 'ATQ-IT070')">{{ $t('header.mb_smartTerminal') }}</a></li>
								<li><a @click="clickRouter('mbHardware','productList', 'AD-1900')">{{ $t('header.mb_cloudPreTerminal') }}</a></li>
								<li><a @click="clickRouter('mbHardware','productList', 'RWSC')">{{ $t('header.mb_robotControlTerminal') }}</a></li>
								<li><a @click="clickRouter('mbHardware','productList', 'weldCloud-phone')">{{ $t('header.mb_handheldTerminal') }}</a></li>

								<li style="font-size: 14px; color: #909399;">{{ $t('header.mb_industrialGateway') }}</li>
								
								<li><a @click="clickRouter('mbHardware','productList', 'ATQ-RS422/4G')">{{ $t('header.mb_commController4GExt') }}</a></li>
								<li><a @click="clickRouter('mbHardware','productList', 'ATQ-GW-DWL')">{{ $t('header.mb_commController4GInt') }}</a></li>
								<li><a @click="clickRouter('mbHardware','productList', 'ATQ-RS422/WF-II')">{{ $t('header.mb_commControllerWifiExt') }}</a></li>
								<li><a @click="clickRouter('mbHardware','productList', 'ATQ-GW-WF801')">{{ $t('header.mb_commControllerWifiInt') }}</a></li>
								<li><a @click="clickRouter('mbHardware','productList', 'ATQ-RS422-5G')">{{ $t('header.mb_commController5G') }}</a></li>
								<li><a @click="clickRouter('mbHardware','productList', 'ATQ-RS422-4G-IV')">{{ $t('header.mb_commControllerMulti') }}</a></li>

								<li style="font-size: 14px; color: #909399;">{{ $t('header.mb_robotGateway') }}</li>

								<li><a @click="clickRouter('mbHardware','productList', 'ATR-485-Ⅱ')">{{ $t('header.mb_robotCommATR485') }}</a></li>
								<li><a @click="clickRouter('mbHardware','productList', 'ATR-CAN-Ⅱ')">{{ $t('header.mb_robotCommATRCAN') }}</a></li>
								<li><a @click="clickRouter('mbHardware','productList', 'ATR-CANOPEN')">{{ $t('header.mb_robotCommATRCANOPEN') }}</a></li>
								<li><a @click="clickRouter('mbHardware','productList', 'ATR-DEV-Ⅳ')">{{ $t('header.mb_robotCommATRDEV') }}</a></li>
								<li><a @click="clickRouter('mbHardware','productList', 'ATR-EtherCAT')">{{ $t('header.mb_robotCommATREtherCAT') }}</a></li>
								<li><a @click="clickRouter('mbHardware','productList', 'ATR-PROFINET')">{{ $t('header.mb_robotCommATRPROFINET') }}</a></li>
								<li><a @click="clickRouter('mbHardware','productList', 'ATR-GATEWAY')">{{ $t('header.mb_robotGatewayDevice') }}</a></li>
								<li><a @click="clickRouter('mbHardware','productList', 'ATR-GW-EIP')">{{ $t('header.mb_robotGatewayEIP') }}</a></li>
								<li style="font-size: 14px; color: #909399;">{{ $t('header.mb_otherDevices') }}</li>

								<li><a @click="clickRouter('mbHardware','productList', 'ATQ-SR')">{{ $t('header.mb_handheldProcessTerminal') }}</a></li>
								<li><a @click="clickRouter('mbHardware','productList', 'ATQ-GFS50')">{{ $t('header.mb_gasFlowMeter') }}</a></li>
								<li><a @click="clickRouter('mbHardware','productList', 'ATQ-NFC')">{{ $t('header.mb_cardReader') }}</a></li>
								
							</ul>
						</li>
						<li class="dropdown">
							<a href="#">
                                <span @click="clickRouter('mbSolutionList')">{{ $t('header.solution') }}</span>
                                <button aria-label="dropdown toggler"><i class="fa fa-angle-down"></i></button>
                            </a>
							<ul>
								<li><a @click="clickRouter('mbSolutionDetail','solutionList', 'pressureVessel')">{{ $t('header.pressureVesselIndustry') }}</a></li>
								<li><a @click="clickRouter('mbSolutionDetail','solutionList', 'ship')">{{ $t('header.shipbuildingIndustry') }}</a></li>
								<li><a @click="clickRouter('mbSolutionDetail','solutionList', 'machinery')">{{ $t('header.machineryIndustry') }}</a></li>
								<li><a @click="clickRouter('mbSolutionDetail','solutionList', 'weldTraining')">{{ $t('header.trainingIndustry') }}</a></li>
								<li><a @click="clickRouter('mbSolutionDetail','solutionList', 'coalMachine')">{{ $t('header.coalMachineIndustry') }}</a></li>
								<li><a @click="clickRouter('mbSolutionDetail','solutionList', 'steelStructureScheme')">{{ $t('header.steelStructureIndustry') }}</a></li>
								<li><a @click="clickRouter('mbSolutionDetail','solutionList', 'piping')">{{ $t('header.pipingIndustry') }}</a></li>
							</ul>
						</li>
						<li class="dropdown">
							<a href="#">
                                {{ $t('header.resourceCenter') }}
                                <button aria-label="dropdown toggler"><i class="fa fa-angle-down"></i></button>
                            </a>
							<ul>
								<li><a @click="clickRouter('mbResourceDownload')">{{ $t('header.downloads') }}</a></li>
								<li><a @click="clickRouter('mbIndustry')">{{ $t('header.industryStandards') }}</a></li>
								<li><a @click="clickRouter('mbCertificate')">{{ $t('header.welderTips') }}</a></li>
								
							</ul>
						</li>
						<li class="dropdown">
							<a @click="clickRouter('mbCase')">{{ $t('header.caseStudies') }}</a>
							
						</li>
						<li class="dropdown">
							<a @click="clickRouter('mbNews')">{{ $t('header.news') }}</a>
						</li>
						
						<li><a @click="clickRouter('mbVideo')">{{ $t('header.videoData') }}</a></li>
						<li><a @click="clickRouter('mbAbout')">{{ $t('header.contactUs') }}</a></li>
						<li><a @click="handleRouter()">{{ $t('header.officialWebsite') }}</a></li>
					</ul>
				</div>

				<!-- 尾部 -->
				<ul class="mobile-nav__contact list-unstyled">
					<li>
						<i class="fa fa-envelope"></i>
						<a href="mailto:needhelp@packageName__.com">qunkong@aotaidianqi.com</a>
					</li>
					<li>
						<i class="fa fa-phone-alt"></i>
						<a href="tel:13205318830">132-0531-8830   {{ $t('footer.footer_contact_manager_wang') }}</a>
					</li>
					<li>
						<i class="fa fa-phone-alt"></i>
						<a href="tel:18353147789">183-5314-7789   {{ $t('footer.footer_contact_manager_xu') }}</a>
					</li>
				</ul>
				



			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'mbHeader',
		created() {
			this.languang = this.$i18n.locale;
		},
		mounted() {
			$(".mobile-nav__toggler").on("click", function (e) {
				e.preventDefault();
				$(".mobile-nav__wrapper").toggleClass("expanded");
				$("body").toggleClass("locked");
			});


			if ($(".mobile-nav__container .main-menu__list").length) {
				let dropdownAnchor = $(
				".mobile-nav__container .main-menu__list .dropdown > a"
				);
				dropdownAnchor.each(function () {
				let self = $(this);
				self.find("button").on("click", function (e) {
					e.preventDefault();
					let self = $(this);
					// 被选元素上添加指定的类，如果元素已经有该类，则移除该类。
					self.toggleClass("expanded");
					self.parent().toggleClass("expanded");
					self.parent().parent().toggleClass("d_action");
					self.parent().parent().children("ul").slideToggle();
				});
				});
			}
			// if(!this.isLoginPage) {
			// 	console.log("页面表头切换样式", this.isLoginPage)
			// 	$(document).ready(function() {
			// 		var scroll_start = 0;
			// 		var change_color = $('.main-header');
			// 		var offset = change_color.offset();

			// 		if (change_color.length) {
			// 			$(document).scroll(function() {
			// 				// console.log("菜单切换")
			// 				scroll_start = $(this).scrollTop();
			// 				if (scroll_start > 0) {
			// 					$(".main-header").removeClass("menu_trans");
			// 				} else {
			// 					$(".main-header").addClass("menu_trans");
			// 				}
			// 			});
			// 		}
			// 	})
			// }

			// 加这一行：首次加载就判断要不要绑 scroll
			if (!this.isLoginPage) this._bindScroll()
			$('.main-header').css("position", "fixed");


			console.log("国际化",this.$i18n.locale)
		},
		computed: {
			// 自动响应路由变化
			isLoginPage() {
				console.log("是否登录页面", this.$route.path)
				return this.$route.path.includes('mbSystem')
			}
		},
		// 响应路由变化：scroll handler 在非登录页才生效
		watch: {
			isLoginPage: {
				immediate: true,   // ← 加这一行
				handler(val) {
					if (val) {
						$(window).off('scroll', this._onScroll)   // ← 同时改 $(document) → $(window)
					} else {
						this.$nextTick(() => this._bindScroll())
					}
				}
			},
			 '$route.path': {
				immediate: true,   // ← 加这一行
				handler() {
					this.$nextTick(() => {
						if (!this.isLoginPage) {
							this._bindScroll()
						}
					})
				}
			}
		},
		data() {
			return {
				languang: 'zh_CN',
			}
		},
		methods: {
			// 绑定 scroll 事件（只在非 mbSystem 页面生效）
			_bindScroll() {
				 $(window).off('scroll', this._onScroll)       // $(document) → $(window)
				this._onScroll = () => {
					if (this.isLoginPage) return
					const scrollTop = $(window).scrollTop()    // $(document) → $(window)
					if (scrollTop > 0) {
						$(".main-header").removeClass("menu_trans")
					} else {
						$(".main-header").addClass("menu_trans")
					}
				}
				$(window).on('scroll', this._onScroll)         // $(dodocument) → $(window)	
			},
			// 路由跳转
			clickRouter(url, classification, type) {
				if (classification == 'productList' || classification == 'solutionList') { // 产品中心 || 解决方案
					if(type) {
						this.$router.push({
							path: url,
							query: {
								type: type
							}
						});
					} else {
							this.$message.warning(this.$t('header.tempUnavailable'));
					}
				
				} else if (classification == 'secondaryMenu') { // 二级菜单  产品中心
					this.$router.push({
						path: url,
						query: {
							type: type
						}
					});
				} else {
					this.$router.push({
						path: url
					});
				}

				$(".d_action").children("ul").slideToggle();
				$(".d_action a button").removeClass("expanded");
				$(".d_action a").removeClass("expanded");
				$(".d_action").removeClass("d_action");
				$(".mobile-nav__wrapper").removeClass("expanded");
				$("body").removeClass("locked");
			},
			handleRouter() {
				const url =  window._address_env_.official //'http://www.aotaidianqi.com/'; // 确保正确的协议，例如 'http://' 或 'https://'
				window.open(url, '_blank');
			},
			// 切换国际化
			handleLang(lang) {
				
				// 保存到 localStorage
				localStorage.setItem('locale', lang);

				this.$i18n.locale = lang;
				this.languang = lang;
				location.reload();
				
			}
		}
	}
</script>
<style scoped>
	@import '../../../../public/static/css/aotai-header.css';
	.main-header--one {
		padding: 0 15px;
	}
	.main-menu .mobile-nav__toggler {
		padding: 20px 0;
	}

	.main-menu .mobile-nav__toggler:hover {
		color: var(--notech-primary-hover);
	}

	.mobile-nav__land {
		margin-right: 15px;
		color: var(--notech-base);
		font-size: var(--font-size-18);
		font-weight: bold;
	}

	.menu_trans .mobile-nav__land{
		color: var(--notech-white);
		
	}

	/* 图标位置 */
	.main-menu__logo {
		padding-top: 20px;
	}

	.main-menu__logo img {
		height: 40px;
	}

	.main-menu__main-menu-box {
		float: right;
	}
	/* 菜单显示 */
	.mobile-nav__content {
		min-width: 300px;
		width: 85%;
	}
	/* 菜单字体大小 */
	.mobile-nav__content .main-menu__list li a {
		font-size: var(--font-size-14);
		
	}
	.mobile-nav__contact li {
		font-size: var(--font-size-14);
	}
	.menu_trans {
		background: transparent;
	}



	

	/* 图标 */
	.menu_trans .mmr_img-dark {
		display: block !important;
	}

	.menu_trans .mmr_img-light {
		display: none !important;
	}

	/* 图标 */
	.mmr_img-dark {
		display: none;
	}

	.mmr_img-light {
		display: block;
	}


	.menu_trans .main-menu__right .main-menu__call-number a {
		color: var(--notech-white)
	}

	/* .menu_trans .main-menu__search {
		color: var(--notech-white) !important;
	} */
	/* 系统体验入口 */
	.menu_trans .el-icon-menu_bg {
		color: var(--notech-white) !important;
	}

	/* 官网入口 */
		/* 图标 */
		.menu_trans .logo-dark {
			display: none !important;
		}

		.menu_trans .logo-light {
			display: block !important;
		}

	.main-menu__search-box:before {
		width: 0px;
	}

	.main-header {
		box-shadow: 0px 2px 4px 0px rgba(19, 17, 67, 0.13);
	}

	.main-menu .main-menu__list li ul {
		position: fixed;
		width: 100%;
		top: 100px;
		left: 0;
		background: #fff;

		transition: top 0.36s;
		height: 459px;
		margin-top: 0px;
		margin-bottom: 0px;

		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
		-webkit-box-pack: start;
		-ms-flex-pack: start;
		justify-content: flex-start;
		-webkit-box-align: start;
		-ms-flex-align: start;
		align-items: flex-start;
		z-index: 99;
		-webkit-box-shadow: 0px 0px 65px 0px rgba(0, 0, 0, 0.1);
		box-shadow: 0px 0px 65px 0px rgba(0, 0, 0, 0.1);
	}
	.main-menu {
		padding: 0;
	}
	.main-menu__main-menu-box {
		cursor: pointer;
	}
	.main-menu__list .two_active {
		display: block !important;
	}

	.main-menu__list a:hover {
		color: var(--notech-base);
	}
	.clearfix {
		zoom: 1;
	}
	.fl {
		float: left;
	}

	/* 二级菜单 */
	.menu_two {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.main-menu .main-menu__list .menu_display:hover>ul,
	.stricky-header .main-menu__list .menu_display:hover>ul {
		opacity: 1;
		visibility: visible;
	}

	.menu_two_left {
		width: 260px;
		height: 100%;
		position: relative;
		background: #fff;
		padding-top: 55px;
		padding-bottom: 55px;
		padding-left: 3.5%;
		padding-right: 64px;
	}


	.menu_two_right {
		background: var(--notech-extra);
		width: calc(100% - 260px);
		height: 100%;
		padding-top: 55px;
		padding-bottom: 55px;
		padding-right: 4%;
		padding-left: 37px;
	}

	/* 左侧菜单 */
	.he_solutu {
		width: 100%;
	}

	.he_solutuli {
		margin-bottom: 23px;
		padding-bottom: 13px;
	}

	.he_solutule {
		width: calc(100% - 20px);
		padding-right: 10px;
		color: var(--notech-black);
	}

	.he_solutule p {
		font-size: var(--font-size-20);
	}

	.he_soluturi {
		width: 20px;

	}

	.fr {
		float: right;
	}

	.he_soluturi img {
		width: 6px;
		height: inherit !important;
		transition: all 0.36s;
		position: relative;
		top: 0;
		left: 0;
	}

	/* 隐藏蓝色 */
	.he_soluturi .he_img1 {
		top: 12px;
		display: none;
		/* opacity: 0; */
	}

	.he_solutuli.nav_active .he_soluturi .he_img {
		/* opacity: 0; */
		display: none;
	}

	.he_solutuli.nav_active .he_soluturi .he_img1 {
		/* opacity: 1; */
		display: block;
	}

	.he_solutuli.nav_active .he_solutule {
		color: var(--notech-base);
	}

	.menu-two-level_right {
		width: calc(100% - 400px);
		padding-right: 4%;
		padding-left: 37px;
		background: var(--notech-base);

	}
	.two_item {
		/* width: 33%; */
		width: auto !important;
		height: 100%;
		padding: 0 20px;
		text-align: left;
	}
	.two_item_title {
		font-size: var(--font-size-20);
		line-height: 1.75;
		color: var(--notech-black);
	}

	.two_item_title div {
		margin-top: 12px;
		width: 40px;
		height: 2px;
		background: var(--notech-base);
	}

	.two_item ul {
		width: 100%;
		height: 100%;
	}

	.two_item_content {
		margin-top: 22px;
		font-size: var(--font-size-16);
		line-height: 36px !important;
		color: var(--notech-gray) !important;
		transition: all 0.36s;
	}

	.two_item:not(:last-child) {
		border-right: 1px solid rgba(221, 221, 221, 0.4);
	}


	.menu_two_right .two_right_item {
		display: none;
	}

	/* 案例 */
	.main-menu__list .case_item {
		margin: 0 auto;
		padding-top: 55px;
		padding-bottom: 55px;
	}

	.menu_resource ul {
		height: 150px !important;
		padding-top: 50px !important;
		margin-top: 0px;
		padding-bottom: 50px !important;
		margin-bottom: 0px;
	}

	.main-menu__list .resource_item {
		font-size: var(--font-size-16);
		margin: 0 auto;
	}

	.two_item_content .about {
		display: -webkit-box;
	}

	.two_item_content .about .icon {
		margin-right: 20px;
	}

	.main-menu__right {
		padding: 0;
		padding-top: 33px;
	}
	
	.main-menu__search {
		cursor: pointer;
		font-size: 25px;
		font-weight: bold;
	}
	.main-menu__land {
		border-radius: 5px;
		padding: 10px 15px;
		color: #fff;
		background-color: var(--notech-base);
		font-size: 18px;
	}
	.main-menu__search-box {
		margin-left: 15px;
	}
	.el-tooltip-menu {
		font-size: 20px;
	}
	.el-icon-menu_bg {
		color: var(--notech-base);
	}
</style>
